import {Service} from "@/services/superclasses/service";
import {FormResponse} from "@/interfaces/form-response";

const api = window.contextPath + '/rest/reset-login-request';

export class ResetLoginRequestService extends Service {

    public create = async (email: string): Promise<FormResponse<string>> => {
        return this.data(await this.post<FormResponse<string>>(api, {
            email: email
        }, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }))
    };
}

export const resetLoginRequestService = new ResetLoginRequestService()